/*
 * @Author: 孙培国
 * @Date: 2022-10-12 17:48:36
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-06-06 16:11:51
 * @FilePath: \dataplaform\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    token: '',
    username: '',
    editNavEventDataStore: {},
    enterpriseId: '',
    productionLineId: '',
    qyID: '',
    baseURL: '',
    yearTime: '',
    queryType: 4,
    menuList: [],
    mapMonitor: [],
    unusualData: [],
    Operation: {
      HistoryCard: false,
      StatisticsCard: false,
      RealTimeCard: true,
      DorwardDiffusionDataCard: false,
      krigingInterCard: false,
      PollutionSourceTrackingCard: false,
      ReverseIdentificationCard: false
    },
    focusCity: {},
    citys: [],
    siteId: '0',
    type: 'ppb',
    showType: '小时值',
    sTime: '',
    eTime: ''
  },
  mutations: {
    set_Focuscity (state, str) {
      state.focusCity = str
    },
    set_queryType (state, str) {
      state.queryType = str
    },
    set_citys (state, str) {
      state.citys = str
    },
    set_qyID (state, str) {
      state.qyID = str
    },
    set_yearTime (state, str) {
      state.yearTime = str
    },
    SET_TOKEN (state, str) {
      state.token = str
    },
    SET_SITEID (state, str) {
      state.siteId = str
    },
    SET_TYPE (state, str) {
      state.type = str
    },
    SET_sTime (state, str) {
      state.sTime = str
    },
    SET_eTime (state, str) {
      state.eTime = str
    },
    SET_SHOWTYPE (state, str) {
      state.showType = str
    },
    SET_OPERATION (state, str) {
      state.Operation = str
    },
    SET_USERNAME (state, str) {
      state.username = str
    },
    set_enterpriseId (state, str) {
      state.enterpriseId = str
    },
    set_productionLineId (state, str) {
      state.productionLineId = str
    },
    SET_EDITNAVEVENTDATASTORE (state, str) {
      state.editNavEventDataStore = str
    },
    logout () {
      this.$router.push('/login')
    }
  },
  actions: {

  }

})
export default store
